import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavigationBar from './components/NavigationBar/NavigationBar';
import HeroSection from './components/HeroSection/HeroSection';
import AboutSection from './components/AboutSection/AboutSection';
import ExperienceSection from './components/ExperienceSection/ExperienceSection';
import SkillsSection from './components/SkillsSection/SkillsSection';
import ProjectsSection from './components/ProjectsSection/ProjectsSection';
import EducationSection from './components/EducationSection/EducationSection';
import ConnectSection from './components/ConnectSection/ConnectSection';
import BlogsSection from './components/BlogsSection/BlogsSection';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={
          <>
            <NavigationBar/>
            <HeroSection/>
            <AboutSection/>
            <SkillsSection/>
            <ExperienceSection/>
            <ProjectsSection/>
            <EducationSection/>
            <ConnectSection/>
          </>
        }></Route>
        <Route path='/blogs' element={<BlogsSection/>}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
